import React from "react";
import { KgActivityHistoryIcon } from "../../atoms/KgActivityHistoryIcon";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorReportActivityTab.styles";
import type { KgInspectorReportActivityTabProps } from "./KgInspectorReportActivityTab.types";

export const KgInspectorReportActivityTab: React.FC<
  KgInspectorReportActivityTabProps
> = ({ rows, variant = "report" }) => {
  const isDataStory = variant === "dataStory";
  const emptyHint = isDataStory
    ? "No version history for this data story yet."
    : "No version history for this report yet.";

  const columns = isDataStory
    ? [
        {
          key: "version",
          header: "V#",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.version,
        },
        {
          key: "lastUpdated",
          header: "LAST UPDATED",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.lastUpdated,
        },
        {
          key: "updatedBy",
          header: "UPDATED BY",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.updatedBy,
        },
        {
          key: "context",
          header: "CONTEXT",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.context ?? "—",
        },
      ]
    : [
        {
          key: "version",
          header: "V#",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.version,
        },
        {
          key: "lastUpdated",
          header: "LAST UPDATED",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.lastUpdated,
        },
        {
          key: "updatedBy",
          header: "UPDATED BY",
          width: "equal" as const,
          render: (row: (typeof rows)[number]) => row.updatedBy,
        },
      ];

  return (
    <TabRoot>
      <SectionHeader>
        <IconSlot>
          <KgActivityHistoryIcon size={16} />
        </IconSlot>
        <SectionTitle>Activity</SectionTitle>
        {rows.length > 0 && <CountBadge>{rows.length}</CountBadge>}
      </SectionHeader>

      {rows.length === 0 ? (
        <EmptyHint>{emptyHint}</EmptyHint>
      ) : (
        <KgInspectorDataGrid
          rows={rows}
          rowKey={(row) => row.id}
          contentAlign="start"
          columns={columns}
        />
      )}
    </TabRoot>
  );
};

export default KgInspectorReportActivityTab;
